import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import $ from "jquery";
import { getHeaders } from "../../../utils/apiHelper";
import DateTimeService from "../../../utils/dateTimeService";
import { leaveReportModuleData, leaveReport } from "../../../utils/apiRoutes";
import FiscalYearsDropDown from "./FiscalYearsDropDown";
import SearchButton from "./SearchButton";
import LeaveReportFilters from "./LeaveReportFilters";
import LoadingIndicator from "../../Common/components/LoadingIndicator";
import NoDataFoundIndicator from "../../Common/components/NoDataFoundIndicator";

export default class LeaveReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fiscalYearsInfo: [],
      departments: [],
      branches: [],
      regions: [],
      employeesInfo: [],
      leaveReport: [],
      isLoading: true,
      isLoadingLeaveReport: false,
      hasLoadedLeaveReport: false,
    };
    this.data = {
      filterValues: {
        selectedFiscalYear: 0,
        selectedRegion: 0,
        selectedBranch: 0,
        selectedDepartment: 0,
        selectedEmployee: 0,
        selectedExitStatus: 0,
      },
    };
  }

  getCurrentFiscalYear(fiscalYearsInfo) {
    let currentFiscalYear = fiscalYearsInfo.find((obj) => {
      return new DateTimeService().isDateWithin(
        `${obj.yearStart}-${obj.monthStart}-01`,
        `${obj.yearEnd}-${obj.monthEnd}-31`
      );
    });
    return currentFiscalYear ?? fiscalYearsInfo[0];
  }

  async componentDidMount() {
    const { data: moduleData } = await this.getModuleData();
    if (!!moduleData) this.initModuleData(moduleData);
  }

  getModuleData = async () => {
    const res = await fetch(leaveReportModuleData, {
      headers: getHeaders(),
    });
    if (res.ok) {
      return res.json();
    } else {
      this.setState({
        isLoading: false,
      });
      return null;
    }
  };

  initModuleData = async (moduleData) => {
    moduleData.fiscalYearsInfo.sort(function (a, b) {
      return b.yearStart - a.yearStart;
    });
    // Set initial selected fiscal year
    const currentFiscalYear = this.getCurrentFiscalYear(
      moduleData.fiscalYearsInfo
    );
    this.data.filterValues.selectedFiscalYear = currentFiscalYear.yearStart;
    //_______________________________________________________________________

    moduleData.regions.unshift({ label: "ALL", value: 0 });
    moduleData.branches.unshift({ label: "ALL", value: 0 });
    moduleData.departments.unshift({ label: "ALL", value: 0 });

    this.setState({
      fiscalYearsInfo: moduleData.fiscalYearsInfo,
      regions: moduleData.regions,
      branches: moduleData.branches,
      departments: moduleData.departments,
      employeesInfo: moduleData.employeesInfo,
      isLoading: false,
    });
  };

  handleFilterValue = (filter, value) => {
    const currentFilters = this.data.filterValues;
    if (currentFilters[filter] === value) return;
    currentFilters[filter] = value;
    this.data.filterValues = currentFilters;
  };

  getLeaveReport = async () => {
    const {
      selectedFiscalYear,
      selectedRegion,
      selectedBranch,
      selectedDepartment,
      selectedEmployee,
      selectedExitStatus,
    } = this.data.filterValues;

    this.setState({ isLoadingLeaveReport: true });

    const regionId = selectedRegion === 0 ? "" : `/${selectedRegion}`;
    const branchId = selectedBranch === 0 ? "" : `/${selectedBranch}`;
    const departmentId =
      selectedDepartment === 0 ? "" : `/${selectedDepartment}`;
    const userId = selectedEmployee === 0 ? "" : `/${selectedEmployee}`;

    const leaveReportRoute = leaveReport(
      selectedFiscalYear,
      regionId,
      branchId,
      departmentId,
      userId,
      selectedExitStatus
    );
    const res = await fetch(leaveReportRoute, {
      headers: getHeaders(),
    });
    if (res.ok) {
      const { data } = await res.json();
      this.setState({
        isLoadingLeaveReport: false,
        leaveReport: data,
        hasLoadedLeaveReport: true,
      });
      if (data.length > 0) {
        this._setTableData();
      }
    } else {
      this.setState({
        isLoadingLeaveReport: false,
      });
      toast.error("Something went wrong. Unable to get leave report data.");
    }
  };

  _setTableData() {
    let table;
    let list = [];
    let obj,
      one = [];

    let leaveReport = this.state.leaveReport;
    let leaveCategories;
    for (let i = 0; i < leaveReport.length; i++) {
      obj = leaveReport[i];

      one = {
        id: obj.employment_id,
        fullname: obj.fullname,
        designations: obj.designations,
      };

      for (let j = 0; j < obj.details.length; j++) {
        const balance = obj.details[j];
        one[balance.leave_category_id] = `${balance.taken} / ${balance.total}`;
      }

      if (!leaveCategories) {
        leaveCategories = obj.details.map((detail) => {
          return {
            title: detail.leave_category,
            data: detail.leave_category_id,
          };
        });
      }

      list.push(one);
    }

    if ($.fn.dataTable.isDataTable("#dataTables-leaveReport")) {
      table = $("#dataTables-leaveReport").dataTable();
      table.fnClearTable();
      table.fnDestroy();
      $("#dataTables-leaveReport").empty();
    }

    let column = [
      { title: "ID", data: "id" },
      { title: "Name", data: "fullname" },
      { title: "Designation", data: "designations" },
      ...leaveCategories,
    ];

    table = $("#dataTables-leaveReport").DataTable({
      pageLength: 50,
      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      paging: true,
      dom: "Bfrtip",
      buttons: ["copy", "csv", "excel", "pdf"],
      data: list,
      columns: column,
    });
  }

  render() {
    if (this.state.isLoading) return <LoadingIndicator />;

    return (
      <div className="row border-bottom white-bg dashboard-header">
        <ToastContainer position={toast.POSITION.TOP_RIGHT} />
        <div className="row" style={{ marginBottom: 10 }}>
          <FiscalYearsDropDown
            fiscalYearsInfo={this.state.fiscalYearsInfo}
            getCurrentFiscalYear={this.getCurrentFiscalYear}
            onSelect={this.handleFilterValue}
          />
          <SearchButton onSearch={this.getLeaveReport} />
        </div>

        <LeaveReportFilters
          handleFilterValue={this.handleFilterValue}
          regions={this.state.regions}
          branches={this.state.branches}
          departments={this.state.departments}
          employeesInfo={this.state.employeesInfo}
        />

        {this.state.hasLoadedLeaveReport &&
          this.state.leaveReport.length === 0 && (
            <NoDataFoundIndicator marginTop={35} />
          )}

        {this.state.isLoadingLeaveReport ? (
          <LoadingIndicator marginTop={35} backgroundColor="#ffffff" />
        ) : (
          <div className="row container mt20">
            <table
              width="99%"
              className="table table-striped table-bordered table-hover "
              id="dataTables-leaveReport"
            />
          </div>
        )}
      </div>
    );
  }
}
